import { useNavigate } from "react-router-dom";
import { ArrowLeft, BookOpenText } from "lucide-react";
import grammar from "@/data/grammar.json";
import Reveal from "@/components/Reveal";

const totalRules = grammar.levels.reduce((n, l) => n + l.rules.length, 0) || 72;

const GrammarTeaser = () => {
  const navigate = useNavigate();
  return (
    <section id="grammar" className="bg-navy-900 py-16 sm:py-24">
      <div className="container-x">
        <Reveal>
          <div className="relative overflow-hidden rounded-3xl border border-gold/25 bg-navy-800/70 p-7 sm:p-12">
            <div className="absolute -left-20 -top-20 h-64 w-64 rounded-full bg-teal-500/8 blur-3xl" aria-hidden="true" />
            <div className="relative z-10 flex flex-col items-start gap-8 lg:flex-row lg:items-center lg:justify-between">
              <div className="max-w-2xl">
                <p className="mb-3 flex items-center gap-2 text-sm font-semibold text-gold">
                  <BookOpenText className="h-4 w-4" />
                  دليل شامل — مجاني داخل الموقع
                </p>
                <h2 className="text-2xl font-bold leading-snug sm:text-3xl lg:text-4xl">
                  دليل القواعد من A1 إلى C1 — {totalRules} قاعدة مشروحة بالعربية
                </h2>
                <p className="mt-4 leading-loose text-ink-soft sm:text-lg">
                  كل قاعدة بتصيغها الإنجليزية، شرحها بالعربية، مثال مترجم، والخطأ الشائع الذي يقع فيه الطلاب — مع بحث فوري وتصفح حسب المستوى.
                </p>
                <div className="mt-6 flex flex-wrap gap-2">
                  {grammar.levels.map((l) => (
                    <span
                      key={l.key}
                      className="flex min-h-[40px] items-center gap-2 rounded-full border border-white/10 bg-navy-900/60 px-4 text-sm font-bold"
                      style={{ color: l.color }}
                    >
                      <span className="h-2 w-2 rounded-full" style={{ backgroundColor: l.color }} />
                      <span className="font-en">{l.key}</span>
                    </span>
                  ))}
                </div>
              </div>
              <button
                data-testid="grammar-teaser-cta"
                onClick={() => navigate("/grammar")}
                className="flex min-h-[52px] shrink-0 items-center gap-2 rounded-2xl bg-teal-600 px-6 text-base font-bold text-white transition hover:-translate-y-0.5 hover:bg-teal-500"
              >
                افتح دليل القواعد
                <ArrowLeft className="h-5 w-5" />
              </button>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default GrammarTeaser;
